import * as types from '../actions/actionTypes';
import initialState from './initialState';

// Truck receipts scoped to a run: the full list returned by /api/runs/{runId}/receipts
// (both unassigned candidates and receipts already assigned to this run). Consumers derive
// the unassigned subset with `items.filter(r => !r.runId)`.
export default function runReceiptsReducer(state = initialState.runReceipts, action) {
    switch (action.type) {
        case types.RUN_RECEIPTS_LOADING:
            return {
                ...state,
                runId: action.runId,
                loading: true,
            };
        case types.RUN_RECEIPTS_LOADED:
            return {
                ...state,
                runId: action.runId,
                items: Array.isArray(action.items) ? action.items : [],
                loading: false,
            };
        default:
            return state;
    }
}
